import dayjs from "dayjs";
var numeral = require("numeral");

export const land_status = val => {
  let dict = {
    "0": "立项",
    "1": "在建",
    "2": "在用",
    "3": "闲置"
  };
  return dict[val];
};
// 单位规模
export const property_scale = val => {
  let dict = {
    "0": "总资产五百万以下",
    "1": "总资产五百万以上",
    "2": "总资产一千万以上",
    "3": "总资产一亿以上"
  };
  return dict[val];
};

// 单位性质
export const property_type = val => {
  let dict = {
    "0": "工会机关",
    "1": "省（区、市）总机关",
    "2": "市（地）总机关",
    "3": "县（区）总机关",
    "4": "产业工会",
    "5": "省级产业工会机关",
    "6": "市级产业工会机关",
    "7": "事业单位和社会团体",
    "12": "企业",
    "8": "公益一类",
    "9": "公益二类",
    "10": "待分类",
    "11": "社会团体"
  };
  return dict[val];
};

// 单位类别
export const category_type = val => {
  let dict = {
    "13": "省（区、市）总机关",
    "14": "市（地）总机关",
    "15": "县（区）总机关",
    "16": "省级产业工会机关",
    "17": "市级产业工会机关",
    "18": "机关服务中心",
    "19": "信息中心",
    "20": "对外交流中心",
    "21": "工运研究机构",
    "22": "学校",
    "23": "工人文化宫",
    "24": "工人体育场馆",
    "25": "新闻出版演艺单位",
    "26": "工人疗休养院",
    "27": "俱乐部",
    "28": "职工旅行社",
    "29": "宾馆饭店",
    "30": "职工互助保障组织",
    "31": "基金会",
    "32": "工会帮扶中心（职工服务中心）",
    "33": "其他事业单位或社会团体",
    "34": "新闻出版演艺单位",
    "35": "工人疗休养院",
    "36": "职工旅行社",
    "37": "宾馆饭店",
    "38": "工会帮扶中心（职工服务中心）",
    "39": "企业集团",
    "40": "其他企业"
  };
  return dict[val];
};

// 服务领域
export const service_type = val => {
  let dict = {
    "42": "职工疗休养和旅游服务事业",
    "43": "职工互助保障和职工服务事业",
    "44": "工会机关和机关服务事业",
    "41": "职工文化教育传媒体育服务事业"
  };
  return dict[val];
};

// 用户角色 role_name
export const user_role = val => {
  let dict = {
    "0": "超级管理员",
    "1": "管理员",
    "2": "部门领导",
    "3": "普通用户"
  };
  return dict[val];
};

// 时间格式
export const timeFormat = val => {
  return dayjs(val).format("YYYY-MM-DD");
};

// 筛选格式化结果
export const formatNum = num => {
  return numeral(num).format("0,0.00");
};

// 栋 次 张 调用方法
export const formatSingleNum = num => {
  if (String(num) === "0") {
    return "0";
  } else if (!num) {
    return "";
  }
  return numeral(num).format("0,0");
};

// 保留两位小数位
export const formatNumPoint = num => {
  if (String(num) === "0") {
    return "0";
  } else if (!num) {
    return "";
  }

  let a = numeral(num).format("0,0.00");
  return a;
};

// 元变万元，小数并保留两位小数位
export const formatNumTenThousandsPoint = num => {
  if (String(num) === "0") {
    return "0";
  } else if (!num) {
    return "";
  }

  let a = numeral(Number(num) / 10000).format("0,0.00");
  return a;
};

export const formatFloatToPercent = floatNumber => {
  // 百分号
  if (floatNumber === null || floatNumber === undefined || floatNumber === "") {
    return "";
  } else if (floatNumber == "0") {
    return "0%";
  } else {
    let floatString = `${Number(floatNumber * 100).toFixed(2)}%`;
    return floatString;
  }
};
